import { render, staticRenderFns } from "./CustomRule.vue?vue&type=template&id=6d16829d&scoped=true"
import script from "./CustomRule.vue?vue&type=script&lang=js"
export * from "./CustomRule.vue?vue&type=script&lang=js"
import style0 from "./CustomRule.vue?vue&type=style&index=0&id=6d16829d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d16829d",
  null
  
)

export default component.exports